import { storeToRefs } from 'pinia'
import { onMounted, ref, watchEffect } from 'vue'

import useItemCounts from './use-comms-header-item-data'

import { useChecksStore } from '@app/application/sf-assistant-checks/stores/checks'

export function useCommsNewIndicatorBroadcast() {
  const isMounted = ref(false)

  const { unreadNotesCount, unreadTodosCount } = useItemCounts()

  const assistantChecksStore = useChecksStore()
  const { unreadChecks } = storeToRefs(assistantChecksStore)

  onMounted(() => {
    isMounted.value = true
  })

  watchEffect(() => {
    if (!isMounted.value) {
      return
    }

    const numericUnreadNotesCount = parseInt(unreadNotesCount.value || 0, 10)
    const numericUnreadTodosCount = parseInt(unreadTodosCount.value || 0, 10)
    const numericUnreadChecks = parseInt(unreadChecks.value.length || 0, 10)

    const totalUnread =
      numericUnreadNotesCount + numericUnreadTodosCount + numericUnreadChecks

    window.eventHub.$emit(
      'drawer:communication:unread-item-count-changed',
      totalUnread
    )
  })
}
